import { render, staticRenderFns } from "./listaEvaluaciones.vue?vue&type=template&id=60b80769&scoped=true"
import script from "./listaEvaluaciones.vue?vue&type=script&lang=js"
export * from "./listaEvaluaciones.vue?vue&type=script&lang=js"
import style0 from "./listaEvaluaciones.vue?vue&type=style&index=0&id=60b80769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b80769",
  null
  
)

export default component.exports